module.exports = __webpack_public_path__ + "img/company19.ba8e87c6.png";